export const makeStatefulRowEffects = ({
  baseStyle,
  isSelected,
  hoverOpacity = 0.7,
  selectedHoverOpacity = 0.5,
  selectedOutline = '0px solid #ff0000ff',
}) => {
  return (rowData, index) => {
    const base = (baseStyle && baseStyle(rowData, index)) || {};
    const selected = isSelected ? !!isSelected(rowData) : false;

    // Variables css
    const vars = {
      ['--hover-brightness']: selected ? selectedHoverOpacity : hoverOpacity,
    };

    const selectedFx = selected
      ? {
          outline: selectedOutline,
          outlineOffset: '-2px',
        }
      : {};

    return {
      ...base,
      ...vars,
      ...selectedFx,
    };
  };
};
